/** @jsxImportSource @emotion/react */
import { ClassNames, css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSetRecoilState } from "recoil";
import { TempCampaignAtom } from "../../../../atoms/CampaignAtom";
import { Campaign, INode, INodeTypes } from "../../../../types/CampaignTypes";
import IconBerserkerMail from "../../../Icon";
import StyledInput from "../../../StyledInput";
import StyledTextArea from "../../../StyledTextArea";
import Form, { DefaultFormProps, FormInstance } from "./Form";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  padding: 30px;
  overflow-y: auto;
`;

export const Title = styled.div`
  color: #2f2f2f;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0px;
  margin-bottom: 18px;
  display: flex;
  flex-direction: row;
`;

export const FirstRow = styled.div``;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const Label = styled.span`
  color: #2f2f2f;
  letter-spacing: 0px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const InputCss = css`
  height: 46px;
  width: 100%;
`;

const Optional = styled.span`
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #2f2f2f;
  opacity: 0.5;
`;

const PushNotification = ({
  action,
  nodeIndex,
}: DefaultFormProps): JSX.Element => (
  <Form {...{ action, nodeIndex }}>
    {({
      updateCampaign,
      tempCampaign,
      updateNodeDescription,
    }: FormInstance) => {
      const [name, setName] = useState<string>("");
      const [title, setTitle] = useState<string>("");
      const [content, setContent] = useState<string>("");
      const [link, setLink] = useState<string>("");
      const [editing, setEditing] = useState<boolean>(true);

      const currentNode = tempCampaign?.nodes[nodeIndex];

      useEffect(() => {
        if (currentNode) {
          setName(currentNode.name || "");
          setTitle(currentNode.pushNotification?.title || "");
          setContent(currentNode.pushNotification?.content || "");
          setContent(currentNode.pushNotification?.link || "");
          setEditing(action === "edit");
        }
      }, [action, nodeIndex]);

      useEffect(() => {
        updateNodeDescription(name);
      }, [name]);

      const saveForm = () => {
        if (content && title && name) {
          const newAction: INode = {
            _id: currentNode?._id,
            name: name as string,
            type: INodeTypes.PushNotification,
            pushNotification: {
              title,
              content,
            },
          };

          updateCampaign(
            newAction,
            action === "create" ? "Email created" : "Email updated"
          );
        } else {
          toast("All fields are required", { type: "info" });
        }
      };

      const Component = (
        <Container>
          <Title>
            <IconBerserkerMail name="bell" />
            &nbsp;PUSH NOTIFICATION
          </Title>

          <Row>
            <Label>Push Notification Name</Label>
            <StyledInput
              disabled={!editing}
              placeholder="Enter push notification name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Row>

          <Row>
            <Label>Title</Label>
            <StyledInput
              disabled={!editing}
              placeholder="Enter push notification title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Row>

          <Row>
            <Label>Message</Label>
            <StyledTextArea
              disabled={!editing}
              placeholder="Enter push notification message"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
          </Row>

          <Row>
            <Label>
              Link <Optional>(Optional)</Optional>
            </Label>
            <StyledInput disabled={!editing} placeholder="Enter URL" />
          </Row>
        </Container>
      );

      return {
        Component,
        saveForm,
      };
    }}
  </Form>
);

export default PushNotification;
